import {
  createLazyContext,
  useLazyContextProvider,
  useRequiredContext,
} from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { Parcel } from "@redotech/redo-model/outbound-labels/parcel";
import { OrderManagementPermissions } from "@redotech/redo-model/permissions";
import { createContext, memo, ReactNode } from "react";
import { RedoOutboundLabelsRpcClientContext } from "../outbound-labels-rpc-client";

export const ParcelContext = createLazyContext<readonly Parcel[]>();

export const ReloadParcelsContext = createContext<
  (() => Promise<void>) | undefined
>(undefined);

export const ParcelService = memo(function ParcelService({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const client = useRequiredContext(RedoOutboundLabelsRpcClientContext);

  const canViewParcels = useHasPermission(
    OrderManagementPermissions.SCAN_AND_VERIFY,
  );

  const loadState = useLazyContextProvider<Parcel[]>(async (signal) => {
    if (!canViewParcels) {
      return [];
    }
    const { parcels } = await client.getParcels(null, { signal });
    return parcels;
  });

  const reloadParcels = useHandler(async () => {
    loadState.invalidate();
  });

  return (
    <ParcelContext.internalContext.Provider value={loadState}>
      <ReloadParcelsContext.Provider value={reloadParcels}>
        {children}
      </ReloadParcelsContext.Provider>
    </ParcelContext.internalContext.Provider>
  );
});
